export default "__VITE_ASSET__DtdG6x$g__"